module.exports = __webpack_public_path__ + "static/media/7.60f7b2f5.mp3";